<template>
  <div class="content-login" id="container" @keydown.enter='login'>
    <div style="position: absolute;z-index: 99;width: 50px;height: 50px;left: 0px;bottom: 2%;"
      @dblclick="loginShowClick()">
    </div>
    <!--  <div id="output">
      <div class="vid">
        <video width="100%" height="100%" autoplay muted style="object-fit:fill">
          <source :src='vidsrc' type="video/mp4">
        </video>
      </div> -->
    <!-- <div style="width:100%; height:79px;position:absolute;top:120px; overflow:hidden;">
       <div class="top-icon">
        <div class="tit-icon">

        </div>
       </div>
      </div> -->
    <!--  四航院
      <div @click="backHome" style="width: 3%;height: 6%;background-image: url('/static/img/homepage/60b439fe48f38c333d979a2084912bc.png');background-size: 100% 100%;margin-left: 92%;margin-top: 3.3%;cursor: pointer"></div>
-->
    <!--<div @click="backHome" style="width: 1%;height: 2%;background-image: url('/static/img/aim-icon/返回.png');background-size: 100% 100%;margin-left: 96%;margin-top: 1%;cursor: pointer"></div>-->
    <div class="containerT" v-if="loginShow">
      <div style="margin-top: 42%">
        <form class="form" id="entry_form">
          <input style="background-image: url('/static/img/user_icon_copy.png')" v-model="form.username" type="text"
            placeholder="用户名" id="entry_name">
          <input style="background-image: url('/static/img/lock_icon_copy.png')" v-model="form.password" type="password"
            placeholder="密码" id="entry_password" autocomplete="off">
          <button type="button" @click="login"><span v-if="show" style="font-size: 16px">登 录</span><i v-if="showIc"
              class="el-icon-loading" style="font-size: 20px"></i></button>
          <div id="prompt" class="prompt"></div>
        </form>
      </div>
    </div>
    <div style="width:100%; height:38px;position:absolute;bottom:30px; overflow:hidden;">
    </div>
    <!--  <audio
      autoplay="autoplay"
      controls="controls"
      preload="auto"
      src="../../static/vedio/login.mp4"
    >
    </audio> -->
    <div style="width: 100%;height: 100%;background-color: #ffffff;">
      <div class="error-page">
        <div class="error-container">

          <!-- 完全本地SVG插画 -->
          <svg class="error-illustration" viewBox="0 0 600 320">
            <!-- 渐变定义 -->
            <defs>
              <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#4facfe" />
                <stop offset="100%" stop-color="#00f2fe" />
              </linearGradient>
            </defs>

            <!-- 地面阴影 -->
            <ellipse cx="300" cy="260" rx="140" ry="18" fill="#eef5ff" />

            <!-- 云朵 -->
            <g class="cloud cloud1">
              <circle cx="150" cy="170" r="35" fill="#eaf4ff" />
              <circle cx="185" cy="160" r="45" fill="#eaf4ff" />
              <circle cx="225" cy="175" r="35" fill="#eaf4ff" />
            </g>

            <g class="cloud cloud2">
              <circle cx="390" cy="150" r="30" fill="#f1f7ff" />
              <circle cx="420" cy="140" r="40" fill="#f1f7ff" />
              <circle cx="460" cy="155" r="30" fill="#f1f7ff" />
            </g>

            <!-- 404 主文字 -->
            <text x="50%" y="150" text-anchor="middle" class="svg-404" fill="url(#textGradient)">
              404
            </text>

          </svg>

          <div class="error-text">页面走丢了</div>
          <div class="error-desc">
            您访问的资源不存在或已被移除
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../service/authorityService.js'
import leftservice from "../service/leftService.js";
import { initWebSocket } from '../config/webScoket'
import axios from 'axios';
export default {
  components: {

  },
  data() {
    return {
      vidsrc: require('../../static/vedio/login.mp4'),
      show: true,
      showIc: false,
      loginShow: false,
      form: {
        password: '',
        username: ''
      }
      /*loginBanner,
      loginLogo,
      show_num:[],
      form: {
        username: '',
        password: '',
        code:'',
      },
      rules: {
      },*/
    }
  },
  methods: {
    enterprise() {
      this.$router.push({ name: 'Enterprise' })
    },
    bigScreen() {
      this.$router.push({ name: 'BigScreen' })
    },
    /* phones() {
       var ph=document.getElementById("phone");
       var otime=null;
       var num=-300;
       function tomove(){
         otime=setInterval(function (){
           num+=10;
           if(num==1100)
           {
             num=-300;
             clearInterval(otime);
           }
           ph.style.backgroundPosition=num+"px 0px";
         },30)
       }
       tomove();
       setInterval(function(){
         tomove();
       },3000);
     },*/
    /*dj(){
      this.draw(this.show_num)
    },*/
    login(e) {
      this.loginShow = false
      this.show = false
      this.showIc = true
      this.$store.state.loginStatus = true
      if (e) {
        e.preventDefault()
      }
      if (this.form.username !== '' && this.form.password !== '') {
        let name = this.form.username
        service.login(this.form).then(res => {
          // 存储用户信息至localStorage里
          localStorage.setItem('Authorization', res.token)
          localStorage.setItem('username', this.form.username)
          localStorage.setItem('userId', res.userId)
          let userInfo = JSON.stringify(res)
          localStorage.setItem('userInfo', userInfo)
          if (this.form.username == 'zhongshui') {
            this.$router.push({ name: 'ImportScreen' })
          } else {
            // 页面进行跳转
            this.$router.push({ name: 'Home' })
          }
          // 开启websocket
          initWebSocket();
          // 查询完整的树目录
          // this.getAllTree()
        }).catch(err => {
          this.show = true
          this.showIc = false
          this.$Message.error(err.message)
        })
      } else {
        this.show = true
        this.showIc = false
        this.$Message.error('用户名或密码不能为空')
      }
    },
    getQueryParams(url) {
      let params = {};
      let queryString = url.split('?')[1];
      if (!queryString) return params;
      queryString.split('&').forEach(param => {
        let [key, value] = param.split('=');
        params[key] = decodeURIComponent(value);
      });
      return params;
    },
    // 查询完整的树目录结构
    getAllTree() {
      let _this = this
      leftservice.getAllTree().then(res => {
        let node = this.forTreeChildren(res[0])
        setTimeout(() => {
          _this.$store.state.nodeAll = [node]
        }, 3000)
      })
    },
    // 递归遍历树结构
    forTreeChildren(node) {
      if (node == null) {
        console.log("node为空")
        return node
      } else {
        if (node.children == null) {

        } else {
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].type == "logicalGroup") {
              node.children[i].children.forEach((item, index) => {
                if (item.type == "deviceGroup") {
                  leftservice.getTree('Point', item.id).then(res => {
                    item.children = res[0].children
                    /* res[0].children.forEach(item1 => {
                      leftservice.getTree('Point', item1.id).then(restree => {
                        item1.children = restree[0].children
                      })
                    }) */
                  })
                }
              })
            }
            this.forTreeChildren(node.children[i])
          }
          return node
        }

      }
    },
    //验证码效果  by zyp
    /*  draw(show_num) {
        var canvas_width=document.getElementById('canvas').clientWidth;
        var canvas_height=document.getElementById('canvas').clientHeight;
        var canvas = document.getElementById("canvas");//获取到canvas的对象，演员
        var context = canvas.getContext("2d");//获取到canvas画图的环境，演员表演的舞台
        canvas.width = canvas_width;
        canvas.height = canvas_height;
        var sCode = "A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0,q,w,e,r,t,y,u,i,o,p,a,s,d,f,g,h,j,k,l,z,x,c,v,b,n,m";
        var aCode = sCode.split(",");
        var aLength = aCode.length;//获取到数组的长度

        for (var i = 0; i <= 3; i++) {
          var j = Math.floor(Math.random() * aLength);//获取到随机的索引值
          var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
          var txt = aCode[j];//得到随机的一个内容
          show_num[i] = txt;
          var x = 10 + i * 20;//文字在canvas上的x坐标
          var y = 20 + Math.random() * 2;//文字在canvas上的y坐标
          context.font = "bold 20px 微软雅黑";

          context.translate(x, y);
          context.rotate(deg);

          context.fillStyle = this.randomColor();
          context.fillText(txt, 0, 0);

          context.rotate(-deg);
          context.translate(-x, -y);
        }
        for (var i = 0; i <= 5; i++) { //验证码上显示线条 
          context.strokeStyle = this.randomColor();
          context.beginPath();
          context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
          context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
          context.stroke();
        }
        for (var i = 0; i <= 30; i++) { //验证码上显示小点
          context.strokeStyle = this.randomColor();
          context.beginPath();
          var x = Math.random() * canvas_width;
          var y = Math.random() * canvas_height;
          context.moveTo(x, y);
          context.lineTo(x + 1, y + 1);
          context.stroke();
        }
      },*/
    //动态获取随机颜色
    /* randomColor() {//得到随机的颜色值
       var r = Math.floor(Math.random() * 256);
       var g = Math.floor(Math.random() * 256);
       var b = Math.floor(Math.random() * 256);
       return "rgb(" + r + "," + g + "," + b + ")";
     },*/
    loginShowClick() {
      this.loginShow = !this.loginShow
    },
  },
  mounted() {
    /*this.phones()*/
    /*this.draw(this.show_num)*/
    /*$(function(){
      Victor("container", "output");   //登陆背景函数
      $("#entry_name").focus();
      $(document).keydown(function(event){
        if(event.keyCode==13){ 
          $("#entry_btn").click();
        }
      });
    });*/
    const parseUrl = decodeURIComponent(window.location.href);
    const queryParams = this.getQueryParams(parseUrl);
    if (queryParams && queryParams.exe) {
      const axiosConfig = {
        method: "post",
        url: queryParams.loginUrl,
        data: {
          username: queryParams.username,
          password: queryParams.password,
        },
        headers: {
          "Content-Type": "application/json",
        },
      };
      axios(axiosConfig)
        .then(res => {
          console.log("请求成功:", res.data)
          localStorage.setItem('Authorization', res.data.data.token)
          localStorage.setItem('username', res.data.data.username)
          localStorage.setItem('userId', res.data.data.userId)
          let userInfo = JSON.stringify(res.data.data)
          localStorage.setItem('userInfo', userInfo)
          localStorage.setItem('exe', queryParams.exe)
          // 页面进行跳转
          this.$router.push({ name: 'Home' })
          // 开启websocket
          initWebSocket();
        })
        .catch(err => {
          console.error("请求失败:", err)
          this.$Message.error('请求失败,请联系管理员检查')
        });
    }


    // if (queryParams.exe === "true") {
    //   axiosConfig.url = "新的请求地址"; // 只改 URL

    // }
    // console.log("exe:", queryParams.exe);
    // console.log("username:", queryParams.username);
    // console.log("password:", queryParams.password);
    // console.log("loginUrl:", queryParams.loginUrl);
    // const params = url.split('Authorization=')[1].split('&')[0];
    // console.log(params);
    // document.cookie = `Authorization=${params}; path=/`;
  },
}
</script>
<style scoped>
@import "../style/css/loginStyle.css";

@font-face {
  font-family: "webfont";
  font-display: swap;
  src: url("//at.alicdn.com/t/webfont_v27q6i8olu.eot");
  /* IE9*/
  src: url("//at.alicdn.com/t/webfont_v27q6i8olu.eot?#iefix") format("embedded-opentype"),
    /* IE6-IE8 */
    url("//at.alicdn.com/t/webfont_v27q6i8olu.woff2") format("woff2"),
    url("//at.alicdn.com/t/webfont_v27q6i8olu.woff") format("woff"),
    /* chrome、firefox */
    url("//at.alicdn.com/t/webfont_v27q6i8olu.ttf") format("truetype"),
    /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
    url("//at.alicdn.com/t/webfont_v27q6i8olu.svg#杨任东竹石体-Bold") format("svg");
  /* iOS 4.1- */
}

.web-font {
  color: #3f96ff;
  font-size: 20px;
  font-weight: 800;
  font-family: "webfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

#phone {
  width: 1100px;
  margin: 0 auto;
  display: inline-block;
  margin: 10px;
  font-size: 20px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.5);
  background: -webkit-linear-gradient(-30deg,
      rgba(255, 255, 255, 0) 100px,
      rgba(255, 255, 255, 1) 180px,
      rgba(255, 255, 255, 1) 240px,
      rgba(255, 255, 255, 0) 300px) -300px 0 no-repeat;
  -webkit-background-clip: text;
}

.vid {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}

.error-page {
  width: 100%;
  height: 100vh;
  background: linear-gradient(180deg, #f7fbff 0%, #ffffff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial, Helvetica, sans-serif;
}

.error-container {
  text-align: center;
}

/* SVG */

.error-illustration {
  width: 420px;
  max-width: 85vw;
}

.svg-404 {
  font-size: 120px;
  font-weight: bold;
  animation: float 3s ease-in-out infinite;
}

/* 云朵动画 */

.cloud {
  animation: cloudMove 6s ease-in-out infinite;
}

.cloud2 {
  animation-delay: 2s;
}

/* 文案 */

.error-text {
  font-size: 24px;
  color: #444;
  margin-top: 20px;
}

.error-desc {
  color: #888;
  margin-top: 8px;
  font-size: 15px;
}

/* 动画 */

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-12px);
  }
}

@keyframes cloudMove {

  0%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(18px);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue